import type { JSX, PropsWithChildren } from 'react';
import { styled } from 'styled-components';
import { Label } from '../Label';

const Container = styled.div`
  display: grid;
  gap: var(--wui-space-01);
  grid-template-columns: minmax(0, 1fr);
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const LabelContainer = styled.div`
  padding-top: var(--wui-space-01);
`;

export type ColorListGroupProps = PropsWithChildren<{ label: string }>;

/**
 * Groups `ColorListOption` items under a labeled heading within a `ColorList`.
 */
export const ColorListGroup = ({ label, children }: ColorListGroupProps): JSX.Element => {
  return (
    <Container
      aria-label={label}
      role="group"
    >
      <LabelContainer>
        <Label>{label}</Label>
      </LabelContainer>
      <ItemsContainer>{children}</ItemsContainer>
    </Container>
  );
};

ColorListGroup.displayName = 'ColorListGroup';
